import instance from "@/services/api";

export const flatsListAPI = {
  async getList(body) {
    return await instance()
      .post("/handbook/flat/read/", body)
      .then((res) => res?.data);
  },
  async getResidents() {
    return await instance()
      .get("/floor_map/common/residents/read/")
      .then((res) => res?.data);
  },
  async getEntrances(resident_id) {
    return await instance()
      .get(`floor_map/common/residents/${resident_id}/entrances/read/`)
      .then((res) => res?.data);
  },
  async getFloors(body) {
    return await instance()
      .post("/handbook/flat/floor/", body)
      .then((res) => res?.data);
  },
  async updateFlat(body) {
    return await instance()
      .post("/handbook/flat/upd/", body)
      .then((res) => res?.data);
  },
  async cloneFlat(body) {
    return await instance()
      .post("/handbook/flat/dublicate/", body)
      .then((res) => res?.data);
  },
  async deleteFlat(flat_id) {
    return await instance()
      .delete(`handbook/flat/${flat_id}/del/`)
      .then((res) => res?.data);
  },
};
